module.exports = __webpack_public_path__ + "static/bubble-with-categories-036f78191f0bca5e0423b7c33dde7777.png";